import { l as commonEnums } from './enums-CKrQOJk5.mjs';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const { ChargeSessionCodeType, ChargeSessionCodeProvenance, ChargeSessionType} = commonEnums;
const BASE_DX = {
    evidence: [],
    type: null,
    used: true,
    confidence: 1.0,
    threashold: 0.0,
    automate: false,
    diagnosis_code: '',
    sequence_number: 0
};
const BASE_MOD = {
    evidence: [],
    used: true,
    confidence: 1.0,
    threashold: 0.0,
    automate: false,
    modifier_code: '',
    sequence_number: 0
};
const BASE_PROC = {
    evidence: [],
    confidence: 1.0,
    threashold: 0.0,
    automate: false,
    used: true,
    procedure_name: '',
    procedure_id: null,
    procedure_code: '',
    type: ChargeSessionCodeProvenance.CPT.toLowerCase(),
    units: 1.0
};
const BASE_TECH = {
    code: '',
    provenance: ChargeSessionCodeProvenance.TECH.toLowerCase(),
    units: 1.0
};
const codeMaker = {
    icd: (stub)=>{
        return _object_spread({}, BASE_DX, stub);
    },
    modifier: (stub)=>{
        return _object_spread({}, BASE_MOD, stub);
    },
    procedure: (stub)=>{
        return _object_spread({}, BASE_PROC, stub);
    },
    technical: (stub)=>{
        return _object_spread({}, BASE_TECH, stub);
    }
};
const _isProvenance = (provenance)=>(searchSelection)=>{
        const codeType = `${searchSelection.codeType}`.toUpperCase();
        return codeType === `${provenance}`.toUpperCase();
    };
const _isChange = (...codeTypes)=>{
    const codeSet = new Set(codeTypes.map((codeType)=>codeType.toUpperCase()));
    return (codeChange)=>{
        const { codes: [code] } = codeChange;
        return codeSet.has(`${code.codeType}`.toUpperCase());
    };
};
// -----------------------------
// Predicate functions
// -----------------------------
const isSelectionICD = _isProvenance(ChargeSessionCodeProvenance.ICD);
const isSelectionModifier = _isProvenance(ChargeSessionCodeProvenance.MODIFIER);
const isSelectionCPT = _isProvenance(ChargeSessionCodeProvenance.CPT);
const isSelectionTech = _isProvenance(ChargeSessionType.TECHNICAL);
const codePredicates = {
    isSelectionICD,
    isSelectionModifier,
    isSelectionCPT,
    isSelectionTech
};
const isICDChange = _isChange(ChargeSessionCodeType.DIAGNOSIS, ChargeSessionCodeProvenance.ICD);
const isModifierChange = _isChange(ChargeSessionCodeType.MODIFIER);
const isCPTChange = _isChange(ChargeSessionCodeType.PROCEDURE);
const isTechChange = _isChange(ChargeSessionCodeProvenance.TECH);
const isProcedure = (searchSelection)=>{
    return isSelectionCPT(searchSelection) || isSelectionTech(searchSelection);
};
const isProceduralUpdate = (codeChange)=>{
    const [code] = codeChange.codes;
    return code.codeType === ChargeSessionCodeType.PROCEDURE;
};
// -----------------------------
// Typeguards
// -----------------------------
const isSelection = (selection)=>{
    return `codeInfo` in selection || `codesInfo` in selection && 'context' in selection;
};
const isDxCodes = (codes)=>{
    return codes.every((code)=>`diagnosis_code` in code);
};
const isModCodes = (codes)=>{
    return codes.every((code)=>`modifier_code` in code);
};
// -----------------------------
// General helper functions.
// -----------------------------
const getInvoice = (codeChange)=>{
    var _codeChange_context_invoices;
    return ((_codeChange_context_invoices = codeChange.context.invoices) !== null && _codeChange_context_invoices !== void 0 ? _codeChange_context_invoices : []).find((invoice)=>{
        return invoice.guid === codeChange.context.chargeSession.invoiceId;
    });
};
const getTransaction = (invoice, transactionGuid)=>{
    return (invoice.transactions || []).find((txn)=>txn.guid === transactionGuid);
};
const matchProcedure = (invoiceProcedure, updatedCode)=>{
    if (!invoiceProcedure.procedure_code) return false;
    return updatedCode.code === invoiceProcedure.procedure_code;
};
const matchTech = (invoiceProcedure, updatedCode)=>{
    if (!invoiceProcedure.technical_code) return false;
    return updatedCode.code === invoiceProcedure.technical_code;
};
const getTransactionFromChange = (codeChange)=>{
    if (codeChange.context.transaction) {
        return codeChange.context.transaction;
    }
    const invoice = getInvoice(codeChange);
    return getTransaction(invoice, codeChange.context.chargeSession.transactionId);
};
const getCodesForUpdate = (codeChange)=>{
    //@ts-ignore
    const transaction = codeChange.context.transaction;
    //const transaction = getTransactionFromChange(codeChange);
    const codes = [];
    codeChange.codes.forEach((code)=>{
        if (`${code.provenance}`.toUpperCase() === ChargeSessionCodeProvenance.TECH) {
            if (matchTech(transaction.technical_code, code)) {
                codes.push(transaction.technical_code);
            }
        } else if (code.codeType === ChargeSessionCodeType.PROCEDURE) {
            if (matchProcedure(transaction.procedure, code)) {
                codes.push(transaction.procedure);
            }
        } else if (code.codeType === ChargeSessionCodeType.DIAGNOSIS) {
            transaction.diagnoses.forEach((dx)=>codes.push(dx));
        } else if (code.codeType === ChargeSessionCodeType.MODIFIER) {
            transaction.modifiers.forEach((mod)=>codes.push(mod));
        }
    });
    return codes;
};
const isCodeChangeType = (selection)=>{
    return 'codes' in selection;
};
const getOriginalCodes = (searchSelection, isCodeChange = false)=>{
    var _searchSelection_context_transaction;
    const transaction = (_searchSelection_context_transaction = searchSelection.context.transaction) !== null && _searchSelection_context_transaction !== void 0 ? _searchSelection_context_transaction : {};
    if (isSelection(searchSelection)) {
        if (isProcedure(searchSelection.codeInfo)) {
            return [];
        } else if (isSelectionICD(searchSelection.codeInfo)) {
            return [
                ...transaction.diagnoses
            ];
        } else if (isSelectionModifier(searchSelection.codeInfo)) {
            return [
                ...transaction.modifiers
            ];
        }
    } else if (isCodeChange === true && isCodeChangeType(searchSelection)) {
        if (isCPTChange(searchSelection)) {
            return [
                _object_spread({}, transaction.procedure)
            ];
        } else if (isTechChange(searchSelection)) {
            return [
                _object_spread({}, transaction.technical_code)
            ];
        } else if (isICDChange(searchSelection)) {
            return [
                ...transaction.diagnoses
            ];
        } else if (isModifierChange(searchSelection)) {
            return [
                ...transaction.modifiers
            ];
        }
    }
};
const getBulkOpOriginalCodes = (selectionInfo)=>{
    var _ref;
    var _selectionInfo_context;
    const transaction = (_ref = (_selectionInfo_context = selectionInfo.context) === null || _selectionInfo_context === void 0 ? void 0 : _selectionInfo_context.transaction) !== null && _ref !== void 0 ? _ref : {};
    const isAddOperation = 'codesInfo' in selectionInfo;
    const isDeleteOperation = 'codes' in selectionInfo;
    let searchSelection;
    if (isAddOperation) {
        var _selectionInfo_codesInfo;
        searchSelection = {
            codeInfo: selectionInfo === null || selectionInfo === void 0 ? void 0 : (_selectionInfo_codesInfo = selectionInfo.codesInfo) === null || _selectionInfo_codesInfo === void 0 ? void 0 : _selectionInfo_codesInfo[0],
            context: selectionInfo.context
        };
    } else if (isDeleteOperation) {
        searchSelection = selectionInfo;
    }
    if (isAddOperation && isSelection(searchSelection)) {
        if (isProcedure(searchSelection.codeInfo)) {
            return [];
        } else if (isSelectionICD(searchSelection.codeInfo)) {
            return [
                ...transaction.diagnoses
            ];
        } else if (isSelectionModifier(searchSelection.codeInfo)) {
            return [
                ...transaction.modifiers
            ];
        }
    } else if (isDeleteOperation) {
        if (isCPTChange(searchSelection)) {
            return [
                _object_spread({}, transaction.procedure)
            ];
        } else if (isTechChange(searchSelection)) {
            return [
                _object_spread({}, transaction.technical_code)
            ];
        } else if (isICDChange(searchSelection)) {
            return [
                ...transaction.diagnoses
            ];
        } else if (isModifierChange(searchSelection)) {
            return [
                ...transaction.modifiers
            ];
        }
    }
};
const resequence = (codes)=>{
    // when dxs and mods are add/updated/removed from the list,
    // the frontend informs the backend of the new sequence.
    const sequenced = codes === null || codes === void 0 ? void 0 : codes.map((code, idx)=>{
        return _object_spread_props(_object_spread({}, code), {
            sequence_number: idx + 1
        });
    });
    return sequenced;
};
const _buildTransactionUpdate = (action)=>{
    var _ref;
    var _action_context_transaction;
    const transactionGuid = (_ref = (_action_context_transaction = action.context.transaction) === null || _action_context_transaction === void 0 ? void 0 : _action_context_transaction.guid) !== null && _ref !== void 0 ? _ref : null;
    if (transactionGuid === null) {
        throw new Error('Changes and transaction guids are required for updates.');
    }
    return {
        transactionGuid
    };
};
const _buildTransactionCreate = (action)=>{
    var _ref;
    var _action_context_invoice;
    const invoiceGuid = (_ref = (_action_context_invoice = action.context.invoice) === null || _action_context_invoice === void 0 ? void 0 : _action_context_invoice.guid) !== null && _ref !== void 0 ? _ref : null;
    if (invoiceGuid === null) {
        throw new Error('Invoice guid is required for transaction creation.');
    }
    return {
        invoiceGuid
    };
};
// -----------------------------
// PUBLIC API
// -----------------------------
const updateDTO = (codeChange, searchDrop = false)=>{
    const update = _buildTransactionUpdate(codeChange);
    const codesForUpdate = getCodesForUpdate(codeChange);
    // updates have 4 variations
    // 1. change the units on CPTs
    // 2. change units on Technical charges
    // 3. reorder diagnosis
    // 4. reorder modifiers
    // WE ARE ONLY SUPPORTING 1 & 2 AT THE MOMENT.
    // 1. change the units on CPTs
    // 2. change units on Technical charges
    if (isProceduralUpdate(codeChange)) {
        const [firstCode] = codeChange.codes;
        const [original] = codesForUpdate;
        if (!firstCode || !original) {
            throw new Error('unable to update procedure');
        }
        const isTech = `${codeChange.codes[0].provenance}`.toUpperCase() === 'TECH';
        if (!isTech) {
            update.procedure = codeMaker.procedure(_object_spread_props(_object_spread({}, original), {
                units: firstCode.units
            }));
        } else {
            update.technicalCode = codeMaker.technical(_object_spread_props(_object_spread({}, original), {
                units: firstCode.units
            }));
        }
    } else if (isICDChange(codeChange)) {
        var _getTransactionFromChange_diagnoses;
        const diagnoses = (_getTransactionFromChange_diagnoses = getTransactionFromChange(codeChange).diagnoses) !== null && _getTransactionFromChange_diagnoses !== void 0 ? _getTransactionFromChange_diagnoses : [];
        const updatedDx = [];
        codeChange.codes.forEach((code)=>{
            const dx = diagnoses.find((d)=>d.diagnosis_code === code.code);
            if (dx) {
                updatedDx.push(dx);
            } else if (searchDrop) {
                updatedDx.push(_object_spread_props(_object_spread({}, BASE_DX), {
                    diagnosis_code: `${code.code}`
                }));
            }
        });
        update.diagnoses = resequence(updatedDx);
    } else if (isModifierChange(codeChange)) {
        var _getTransactionFromChange_modifiers;
        const modifiers = (_getTransactionFromChange_modifiers = getTransactionFromChange(codeChange).modifiers) !== null && _getTransactionFromChange_modifiers !== void 0 ? _getTransactionFromChange_modifiers : [];
        const updatedModifiers = [];
        codeChange.codes.forEach((code)=>{
            const modifier = modifiers.find((d)=>d.modifier_code === code.code);
            if (modifier) {
                updatedModifiers.push(modifier);
            } else if (searchDrop) {
                updatedModifiers.push(_object_spread_props(_object_spread({}, BASE_MOD), {
                    modifier_code: `${code.code}`
                }));
            }
        });
        update.modifiers = resequence(updatedModifiers);
    }
    return update;
};
const createDTO = (selection)=>{
    const { codeInfo, context } = selection;
    const createDTO = _buildTransactionUpdate({
        context
    });
    // creation takes two flavors
    // 1. single for cpts/tech
    // 2. multi for dx/mods
    if (isSelectionCPT(codeInfo)) {
        var _ref, _ref1;
        createDTO.procedure = codeMaker.procedure({
            procedure_code: codeInfo.code,
            custom_cpt: (_ref = codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.customCpt) !== null && _ref !== void 0 ? _ref : false,
            units: (_ref1 = codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.units) !== null && _ref1 !== void 0 ? _ref1 : 1.0,
            code_provenances: (codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.codeProvenances) || null
        });
    } else if (isSelectionTech(codeInfo)) {
        var _ref2;
        createDTO.technicalCode = codeMaker.technical({
            code: codeInfo.code,
            units: (_ref2 = codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.units) !== null && _ref2 !== void 0 ? _ref2 : 1.0
        });
    } else {
        const codesToAdd = getOriginalCodes(selection, true);
        if (isSelectionICD(codeInfo)) {
            const dx = codeMaker.icd({
                diagnosis_code: `${codeInfo.code}`.toUpperCase(),
                code_provenances: (codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.codeProvenances) || null
            });
            codesToAdd.push(dx);
            createDTO.diagnoses = resequence(codesToAdd);
        } else if (isSelectionModifier(codeInfo)) {
            const modifier = codeMaker.modifier({
                modifier_code: `${codeInfo.code}`.toUpperCase(),
                modifier_type: codeInfo.modifierType,
                code_provenances: (codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.codeProvenances) || null
            });
            codesToAdd.push(modifier);
            createDTO.modifiers = resequence(codesToAdd);
        }
    }
    return createDTO;
};
const BulkcreateDTO = (selection)=>{
    var _selection_codesInfo, _selection_codesInfo1;
    const createDTO = _buildTransactionUpdate(selection);
    // creation takes two flavors
    // 1. single for cpts/tech
    // 2. multi for dx/mods
    const codesToAdd = getBulkOpOriginalCodes(selection);
    if (isSelectionICD(selection === null || selection === void 0 ? void 0 : (_selection_codesInfo = selection.codesInfo) === null || _selection_codesInfo === void 0 ? void 0 : _selection_codesInfo[0])) {
        var _selection_codesInfo2;
        selection === null || selection === void 0 ? void 0 : (_selection_codesInfo2 = selection.codesInfo) === null || _selection_codesInfo2 === void 0 ? void 0 : _selection_codesInfo2.forEach((codeInfo)=>{
            const dx = codeMaker.icd({
                diagnosis_code: `${codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.code}`.toUpperCase(),
                code_provenances: (codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.codeProvenances) || null
            });
            codesToAdd === null || codesToAdd === void 0 ? void 0 : codesToAdd.push(dx);
        });
        createDTO.diagnoses = resequence(codesToAdd);
    } else if (isSelectionModifier(selection === null || selection === void 0 ? void 0 : (_selection_codesInfo1 = selection.codesInfo) === null || _selection_codesInfo1 === void 0 ? void 0 : _selection_codesInfo1[0])) {
        var _selection_codesInfo3;
        selection === null || selection === void 0 ? void 0 : (_selection_codesInfo3 = selection.codesInfo) === null || _selection_codesInfo3 === void 0 ? void 0 : _selection_codesInfo3.forEach((codeInfo)=>{
            const modifier = codeMaker.modifier({
                modifier_code: `${codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.code}`.toUpperCase(),
                modifier_type: codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.modifierType,
                code_provenances: (codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.codeProvenances) || null
            });
            codesToAdd === null || codesToAdd === void 0 ? void 0 : codesToAdd.push(modifier);
        });
        createDTO.modifiers = resequence(codesToAdd);
    }
    return createDTO;
};
const createTransactionDTO = (selection)=>{
    var _ref, _ref1;
    const createDTO = _buildTransactionCreate(selection);
    createDTO.procedure = codeMaker.procedure({
        procedure_code: selection.code,
        custom_cpt: (_ref = selection === null || selection === void 0 ? void 0 : selection.customCpt) !== null && _ref !== void 0 ? _ref : false,
        units: (_ref1 = selection === null || selection === void 0 ? void 0 : selection.units) !== null && _ref1 !== void 0 ? _ref1 : 1.0,
        code_provenances: (selection === null || selection === void 0 ? void 0 : selection.codeProvenances) || null
    });
    return createDTO;
};
const deleteDTO = (codeChange)=>{
    const deleteDTO = _buildTransactionUpdate(codeChange);
    const isTech = `${codeChange.codes[0].provenance}`.toUpperCase() === 'TECH';
    const [codeToRemove] = codeChange.codes;
    if (isTech) {
        deleteDTO.technicalCode = codeMaker.technical(codeToRemove);
    } else if (isCPTChange(codeChange)) {
        let [codeToSubmit] = getOriginalCodes(codeChange, true);
        deleteDTO.procedure = codeMaker.procedure(codeToSubmit);
    } else {
        let codesToSubmit = getOriginalCodes(codeChange, true);
        const icdRemoval = isICDChange(codeChange) && isDxCodes(codesToSubmit);
        const modifierRemoval = isModifierChange(codeChange) && isModCodes(codesToSubmit);
        if (icdRemoval) {
            const diagnoses = codesToSubmit.filter((code)=>code.diagnosis_code === codeToRemove.code);
            deleteDTO.diagnoses = diagnoses.length === 0 ? [
                {}
            ] : resequence(diagnoses);
        } else if (modifierRemoval) {
            const modifiers = codesToSubmit.filter((code)=>code.modifier_code === codeToRemove.code);
            deleteDTO.modifiers = modifiers.length === 0 ? [
                {}
            ] : resequence(modifiers);
        }
    }
    return deleteDTO;
};
const BulkDeleteDTO = (codeChange)=>{
    const deleteDTO = _buildTransactionUpdate(codeChange);
    const [firstCode] = codeChange.codes;
    let codesToSubmit = getBulkOpOriginalCodes(codeChange);
    const icdRemoval = isICDChange(codeChange) && isDxCodes(codesToSubmit);
    const modifierRemoval = isModifierChange(codeChange) && isModCodes(codesToSubmit);
    if (icdRemoval) {
        const diagnoses = codesToSubmit.filter((code)=>{
            var _codeChange_codes;
            return codeChange === null || codeChange === void 0 ? void 0 : (_codeChange_codes = codeChange.codes) === null || _codeChange_codes === void 0 ? void 0 : _codeChange_codes.some((removeCode)=>removeCode.code === code.diagnosis_code);
        });
        deleteDTO.diagnoses = diagnoses.length === 0 ? [
            {}
        ] : resequence(diagnoses);
    } else if (modifierRemoval) {
        const modifiers = codesToSubmit.filter((code)=>{
            var _codeChange_codes;
            return codeChange === null || codeChange === void 0 ? void 0 : (_codeChange_codes = codeChange.codes) === null || _codeChange_codes === void 0 ? void 0 : _codeChange_codes.some((removeCode)=>removeCode.code === code.modifier_code);
        });
        deleteDTO.modifiers = modifiers.length === 0 ? [
            {}
        ] : resequence(modifiers);
    }
    return deleteDTO;
};

var transactionUpdateDTOFactory = /*#__PURE__*/Object.freeze({
  __proto__: null,
  BulkDeleteDTO: BulkDeleteDTO,
  BulkcreateDTO: BulkcreateDTO,
  codePredicates: codePredicates,
  createDTO: createDTO,
  createTransactionDTO: createTransactionDTO,
  deleteDTO: deleteDTO,
  getTransactionFromChange: getTransactionFromChange,
  isCPTChange: isCPTChange,
  isICDChange: isICDChange,
  isModifierChange: isModifierChange,
  isTechChange: isTechChange,
  resequence: resequence,
  updateDTO: updateDTO
});

export { BulkDeleteDTO as B, createDTO as a, BulkcreateDTO as b, codePredicates as c, deleteDTO as d, createTransactionDTO as e, isICDChange as f, getTransactionFromChange as g, isModifierChange as h, isCPTChange as i, isTechChange as j, resequence as r, transactionUpdateDTOFactory as t, updateDTO as u };
//# sourceMappingURL=transaction-updates-IKU_rSP_.mjs.map
